import { Button } from 'components/Blocks';
import { useToggleV2 } from 'hooks';
import { useLang } from 'locale';

interface ResendButtonCodeProps {
  send: () => Promise<unknown>;
  seconds: number;
}

export function ResendButtonCode({ send, seconds }: ResendButtonCodeProps) {
  const { t } = useLang();

  const [loading, loadingHandle] = useToggleV2();

  const resend = async () => {
    loadingHandle.turnOn();

    try {
      await send();
    } finally {
      loadingHandle.turnOff();
    }
  };

  return (
    <Button
      variant={'outlined'}
      color="gray"
      className=" flex-1 "
      disabled={!!seconds}
      onClick={resend}
      loading={loading}
    >
      {t('resend')}
      {!!seconds && ` (${seconds})`}
    </Button>
  );
}
